// extracted by mini-css-extract-plugin
export default {"wrapper":"Tile_wrapper__scNMz","tile":"Tile_tile__iciNY"};